import React from "react";
import ChecklistBlock from "@/components/blocks/ChecklistBlock";
import WMCBlock from "@/components/blocks/WMCBlock";
import FieldsBlock from "@/components/blocks/FieldsBlock";
import MeasurementsBlock from "@/components/blocks/MeasurementsBlock";
import DataTableBlock from "@/components/blocks/DataTableBlock";
import TextareaBlock from "@/components/blocks/TextareaBlock";
import NoteBlock from "@/components/blocks/NoteBlock";
import PhotoManager from "@/components/PhotoManager";

export default function SectionRenderer({ section, sdata, onBlockChange, surveyId, photos, setPhotos, onCapturePhoto }) {
  return (
    <div className="space-y-5">
      {section.blocks.map((block, i) => {
        const key = block.key || `${block.type}-${i}`;
        const value = block.key ? sdata?.[block.key] : undefined;
        const change = (v) => onBlockChange(block.key, v);
        switch (block.type) {
          case "note":
            return <NoteBlock key={key} block={block} />;
          case "checklist":
            return <ChecklistBlock key={key} block={block} value={value || {}} onChange={change} />;
          case "wmc":
            return <WMCBlock key={key} block={block} value={value || {}} onChange={change} onCapture={onCapturePhoto} photos={photos} />;
          case "fields":
            return <FieldsBlock key={key} block={block} value={value || {}} onChange={change} />;
          case "measurements":
            return <MeasurementsBlock key={key} block={block} value={value || {}} onChange={change} onCapture={onCapturePhoto} />;
          case "table":
            return <DataTableBlock key={key} block={block} value={value || []} onChange={change} />;
          case "textarea":
            return <TextareaBlock key={key} block={block} value={value || ""} onChange={change} />;
          case "photoRegister":
            return <PhotoManager key={key} surveyId={surveyId} photos={photos} setPhotos={setPhotos} />;
          default:
            return null;
        }
      })}
    </div>
  );
}
